import React, { useState, useEffect } from "react";
import { Modal, Select, Button } from "@/components/ui";
import api from "../../../../services/api";
import toast from "react-hot-toast";

export const ApprovalAssignmentForm = ({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  loading,
}) => {
  const [employees, setEmployees] = useState([]);
  const [fetching, setFetching] = useState(true);

  const [formData, setFormData] = useState({
    designerUser: "",
    managerUser: "",
    ownerUser: "",
  });

  // useEffect(() => {
  //   const fetchEmployees = async () => {
  //     try {
  //       const res = await api.get('/teams?limit=1000&includeOwner=true');
  //       const data = res.data?.data || res.data || [];
  //       setEmployees(data);

  //       // Find owner and preselect
  //       const owners = data.filter(emp => emp.role === 'owner');
  //       if (owners.length > 0) {
  //         setFormData(prev => ({ ...prev, ownerUser: owners[0]._id }));
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch employees", err);
  //       toast.error("Failed to fetch team members");
  //     } finally {
  //       setFetching(false);
  //     }
  //   };
  //   if (isOpen) {
  //     fetchEmployees();
  //   }
  // }, [isOpen]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await api.get("/teams?limit=1000&includeOwner=true");

        const users = res.data?.data || res.data || [];

        setEmployees(users);

        const owner = users.find((u) => u.role?.toLowerCase() === "owner");

        if (owner) {
          setFormData((prev) => ({
            ...prev,
            ownerUser: owner._id,
          }));
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to load team members");
      } finally {
        setFetching(false);
      }
    };

    if (isOpen) {
      fetchEmployees();
    }
  }, [isOpen]);

  // const designers = employees.filter(emp => emp.role === 'designer');
  // const projectManagers = employees.filter(emp => emp.role === 'project-manager');
  // const owners = employees.filter(emp => emp.role === 'owner');

  const designers = employees.filter(
    (user) => user.role?.toLowerCase() === "designer",
  );

  const projectManagers = employees.filter(
    (user) => user.role?.toLowerCase() === "project-manager",
  );

  const owner = employees.find((user) => user.role?.toLowerCase() === "owner");

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (
  //     !formData.designerUser ||
  //     !formData.managerUser ||
  //     !formData.ownerUser
  //   ) {
  //     toast.error("Please assign a team member for all approval levels.");
  //     return;
  //   }
  //   onSubmit(formData);
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.designerUser) {
      return toast.error("Please select Designer");
    }

    if (!formData.managerUser) {
      return toast.error("Please select Project Manager");
    }

    onSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Initial Quotation Submission"
      size="2xl"
    >
      <div className="p-4 sm:p-6 bg-white">
        <div className="mb-6">
          <p className="text-sm text-slate-500">
            Submit the initial quotation details and configure the three-layer
            approval hierarchy.
          </p>
        </div>

        <div className="border border-green-200 bg-green-50/30 rounded-xl p-5 shadow-sm">
          <div className="flex items-center gap-2 mb-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-green-600"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <h3 className="text-[12px] font-bold text-slate-700 uppercase tracking-widest">
              THREE-LAYER APPROVAL WORKFLOW
            </h3>
          </div>

          <p className="text-[13px] text-slate-500 mb-6">
            Please assign a team member for each level of the approval process.
            The quotation will be routed to them sequentially.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <div className="flex items-center justify-between gap-4 relative">
              {/* Connecting line */}
              <div className="absolute top-4 left-0 w-full h-[1px] bg-slate-200 z-0 hidden sm:block"></div>

              {/* Step 1: Designer */}
              <div className="flex-1 flex flex-col gap-3 relative z-10 bg-green-50/30 sm:bg-transparent px-2 sm:px-0">
                <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-bold flex items-center justify-center text-sm border-2 border-white mx-auto shadow-sm">
                  1
                </div>
                <div>
                  <label className="text-[12px] font-semibold text-slate-600 mb-1.5 flex items-center gap-1">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="text-slate-400"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <line x1="19" y1="8" x2="19" y2="14" />
                      <line x1="22" y1="11" x2="16" y2="11" />
                    </svg>
                    Designer <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={formData.designerUser}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        designerUser: e.target.value,
                      }))
                    }
                    className="w-full text-sm"
                    disabled={fetching}
                  >
                    <option value="">Select Designer</option>
                    {designers.map((emp) => (
                      <option key={emp._id} value={emp._id}>
                        {emp.name || `${emp.firstName} ${emp.lastName || ""}`}{" "}
                        (Designer)
                      </option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Step 2: Project Manager */}
              <div className="flex-1 flex flex-col gap-3 relative z-10 bg-green-50/30 sm:bg-transparent px-2 sm:px-0">
                <div className="w-8 h-8 rounded-full bg-yellow-100 text-yellow-600 font-bold flex items-center justify-center text-sm border-2 border-white mx-auto shadow-sm">
                  2
                </div>
                <div>
                  <label className="text-[12px] font-semibold text-slate-600 mb-1.5 flex items-center gap-1">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="text-slate-400"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <line x1="19" y1="8" x2="19" y2="14" />
                      <line x1="22" y1="11" x2="16" y2="11" />
                    </svg>
                    Project Manager <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={formData.managerUser}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        managerUser: e.target.value,
                      }))
                    }
                    className="w-full text-sm"
                    disabled={fetching}
                  >
                    <option value="">Select Manager</option>
                    {projectManagers.map((emp) => (
                      <option key={emp._id} value={emp._id}>
                        {emp.name || `${emp.firstName} ${emp.lastName || ""}`}{" "}
                        (Project Manager)
                      </option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* Step 3: Owner */}
              <div className="flex-1 flex flex-col gap-3 relative z-10 bg-green-50/30 sm:bg-transparent px-2 sm:px-0">
                <div className="w-8 h-8 rounded-full bg-green-100 text-green-600 font-bold flex items-center justify-center text-sm border-2 border-white mx-auto shadow-sm">
                  3
                </div>
                {/* <div>
                  <label className="text-[12px] font-semibold text-slate-600 mb-1.5 flex items-center gap-1">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-slate-400">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <line x1="19" y1="8" x2="19" y2="14" />
                      <line x1="22" y1="11" x2="16" y2="11" />
                    </svg>
                    Owner <span className="text-red-500">*</span>
                  </label>
                  <Select
                    value={formData.ownerUser}
                    onChange={(e) => setFormData(prev => ({ ...prev, ownerUser: e.target.value }))}
                    className="w-full text-sm"
                    disabled={fetching}
                  >
                    <option value="">Select Owner</option>
                    {owners.map(emp => (
                      <option key={emp._id} value={emp._id}>
                        {emp.name || `${emp.firstName} ${emp.lastName || ''}`} (Owner)
                      </option>
                    ))}
                  </Select>
                </div> */}
                <div>
                  <label className="text-sm font-medium">Owner</label>

                  <input
                    type="text"
                    disabled
                    value={owner ? owner.name : "No Owner Found"}
                    className="w-full px-3 py-2 border rounded-lg bg-slate-100"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-slate-100">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 border border-slate-200 text-slate-600 rounded-lg hover:bg-slate-50 font-semibold text-sm transition-colors"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-slate-900 text-white rounded-lg hover:bg-black font-semibold text-sm flex items-center gap-2 transition-colors disabled:opacity-70"
                disabled={loading}
              >
                {loading ? (
                  "Submitting..."
                ) : (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                    Submit for Approval
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ApprovalAssignmentForm;
